import { keyBy } from 'lodash';
import { action, observable, makeObservable, runInAction } from 'mobx';
import { createContext } from 'react';
import {
  getInfoApi,
  addWalletAddressApi,
  removeWalletAddressApi,
} from '../api/products-api';
import AccessKey from './classes/bullish/bullish-access-key';
import Products from './classes/product-store';

export class Bullish extends Products {
  name = 'Bullish';
  shortName = 'BLSH';
  longName = 'bullish';
  accessKeys = {};
  ready;

  setApiKeys = (keys) => {
    this.accessKeys = keyBy(
      keys.map((i) => new AccessKey(i)),
      'id',
    );
  };

  addApiKey = async (key) => {
    try {
      const createdKey = await addWalletAddressApi({
        ...key,
        entity: key.entity.id,
      });
      const newKeys = new AccessKey({ ...createdKey, entity: key.entity });
      this.accessKeys[newKeys.id] = newKeys;
    } catch (err) {
      // Messaging to user is handled by api interceptors.
    }
  };

  removeApiKey = async (key) => {
    await removeWalletAddressApi(key.id);
    delete this.accessKeys[key.id];
  };

  fetch = async () => {
    const bullishInfo = await getInfoApi(this.longName);
    this.setApiKeys(bullishInfo.api_credentials);
    runInAction(() => (this.ready = true));
  };

  reset = () => {
    this.ready = null;
  };

  constructor() {
    super();

    makeObservable(this, {
      shortName: observable,
      longName: observable,
      accessKeys: observable,
      ready: observable,
      setApiKeys: action,
      addApiKey: action,
      removeApiKey: action,
      fetch: action,
      reset: action,
    });
  }
}

export const bullish = new Bullish();
window.bullish = bullish;

export default createContext(bullish);
